import { Button, Grid } from '@mui/material';
import { useState } from 'react';

import { SxPropsThemeType } from '@/shared';

export type CustomToggleSectionBtnOnlyProps = {
  children: React.ReactNode;
  btnText: string;
  sx?: SxPropsThemeType;
  isFirstSection?: boolean;
};

const CustomToggleSectionBtnOnly: React.FC<CustomToggleSectionBtnOnlyProps> = ({
  children,
  btnText,
  sx,
  isFirstSection = false,
}) => {
  const [show, setShow] = useState(false);

  const handleShowMore = () => {
    setShow(prevShow => !prevShow);
  };

  return (
    <>
      {show ? (
          <Grid
            item
            container
            xs={12}
            spacing={3}
            sx={{
              ...sx,
            }}
          >
            {children}
          </Grid>
      ) : (
          <Grid
            item
            xs={12}
            sx={{ mt: isFirstSection ? '20px' : '10px' }}
            container
            spacing={3}
            alignItems="center"
            justifyContent="center"
          >
            <Button onClick={handleShowMore}>{btnText}</Button>
          </Grid>
      )}
    </>
  );
};

export default CustomToggleSectionBtnOnly;
